import axios from 'axios';
import { base_url } from './base_urls';

const api = axios.create({
  baseURL: base_url,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Get the token from localStorage before each request
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        const { status, data } = error.response;
  
        if (status === 401 && data.error_code === 215) {
          localStorage.removeItem('token'); 
          window.location.href = '/login'; 
        }
      }
  
      return Promise.reject(error);
    }
);

export default api;

// api.js
// import axios from 'axios';
// import { base_url } from './base_urls';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Request Interceptor to attach token
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//     } else {
//       window.location.href = '/login';
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       localStorage.removeItem("token");
//       window.location.href = '/login';
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;
